import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import { InputControls, MenuDotsOptions } from 'components/common'
import { SelectWithLabel } from 'components/Form'
import { MnemonicsBadge } from 'components/mnemonics'
import ModalDelete from 'components/ModalDelete'
import { getStaticImage } from 'utils/statics'
import { getFormatedDate } from 'utils'

const Subject = ({
  composer,
  subject,
  statesOptions,
  conversationUser,
  chatmailCheckedSubjects,
  setChatmailCheckedSubjects,
  isOpenRemoveModal,
  toggleRemoveModal,
  handleSelectSubject,
  handleStateSubject,
  handleReadSubject,
  handleMnemonicSubject,
  handleDeleteSubject,
  scrollToBottomMenu
}) => (
  <div
    className={`
      chatmail-subject
      ${composer.currentSubject?._id === subject._id ? 'chatmail-subject--active' : ''}
      ${(!subject.read || subject.pendingMsgCount) ? 'chatmail-subject--unread' : ''}
      ${subject.drafts ? 'chatmail-subject--with-drafts' : ''}
    `}
  >
    <div className='chatmail-subject__left-container'>
      <InputControls
        injectType='external'
        className='chat-composer__subjects-checkbox'
        type='checkbox'
        value={chatmailCheckedSubjects[subject._id]}
        onChange={value => setChatmailCheckedSubjects(prevState => ({ ...prevState, [subject._id]: value }))}
      />
      <p
        className='chatmail-subject__name text-ellipsis'
        onClick={() => handleSelectSubject({ subject })}
      >
        {subject.name}
      </p>
    </div>
    <div className='chatmail-subject__right-container'>
      <SelectWithLabel
        classNameWrapper='chat-composer__subjects-filter chat-composer__subjects-filter--inner chatmail-subject__filter'
        options={statesOptions}
        value={statesOptions.find(state => state.value === subject.state)}
        onChange={({ value }) => handleStateSubject({
          userId: conversationUser._id,
          subjectId: subject._id,
          value
        })}
        onMenuOpen={scrollToBottomMenu}
      />
      <button
        className='chat-composer__subjects-read-btn chatmail-subject__read-btn'
        type='button'
        onClick={() => handleReadSubject({
          _userId: conversationUser._id,
          subjectId: subject._id,
          value: !subject.read
        })}
      >
        <figure>
          {!subject.read ? (
            <img src={getStaticImage('/icons/orange-brand/icon-read-off.svg')} alt='Unread' />
          ) : (
            <img src={getStaticImage('/icons/orange-brand/icon-read.svg')} alt='Read' />
          )}
        </figure>
      </button>
      <MenuDotsOptions
        typeOptions='iconButton'
        onClickButton={() => toggleRemoveModal(true)}
        isOpenModalDelete={isOpenRemoveModal}
        toggleDelete={() => {
          toggleRemoveModal(!isOpenRemoveModal)
        }}
        type={'subject'}
        eventDelete={() =>{
          handleDeleteSubject({ userId: conversationUser.id, subjectId: subject._id })
          toggleRemoveModal(!isOpenRemoveModal)
        }}
      />
      {subject.pendingMsgCount > 0 ? (
        <div className='chatmail-subject__mnemonics-wrapper'>
          <MnemonicsBadge
            userId={conversationUser.id}
            subjectId={subject._id}
            value={subject.pendingMsgCount}
            isRead={subject.read}
            onFinish={() => handleMnemonicSubject({
              userId: conversationUser.id,
              subjectId: subject._id
            })}
          />
        </div>
      ) : null}
      <span className='chatmail-subject__date'>{getFormatedDate({ isoString: subject.createdAt })}</span>
    </div>

    {isOpenRemoveModal ? (
      <ModalDelete
        isOpen={isOpenRemoveModal}
        toggle={toggleRemoveModal}
        header={I18n.t('subject_delete_modal_header')}
        text1={I18n.t('subject_delete_modal_text_1')}
        text2={I18n.t('dashboard_operation-cannot-undone')}
        event={() => {
          handleDeleteSubject({
            userId: conversationUser.id,
            subjectId: subject._id
          })
          toggleRemoveModal()
        }}
      />
    ) : null}
  </div>
)

export default Subject
